import styled from "styled-components"

export const createMarkup = (str) => {
  return { __html: str }
}

export const SpinnerContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  opacity: ${(props) => (props.show ? "1" : "0")};
  padding: 5rem 0;
  transition: opacity 0.3s;
  visibility: ${(props) => (props.show ? "visible" : "hidden")};
  z-index: 1;
`
